export const ApiReturnCodeEnum = {
    NONE: 0,
    DB_ERROR: 1,
    OPERATE_SUCCESS: 2,
    OPERATE_FAIL: 3,
    PARAM_ERROR: 4,
    ID_NO_DATA_FOUND: 5,
    EXPIRE: 6,
    NOT_AUTH: 7,
    REPEAT: 8,
    PARSE_ERROR: 9,
    IO_ERROR: 10,
    UNHANDLED: 11,
    TOKEN_VERIFY_FAIL: 13,
    RESPONSE_INTERCEPT: 99
}

export const ApiSearchTypeEnum = {
    FIND_SAME_LEVEL: 0,
    FIND_LOWER_LEVEL: 1
}

export const ApiQueryOrderByEnum = {
    BACKEND_SORT : 0, 
    LATEST: 1,
    OLDEST: 2,
    RELEVANCE: 3
}

export const ApiWebinarSearchTypeEnum = {
    ALL: 0, //detail
    UPCOMING: 1,
    ARCHIVE: 2
}

export const videoTypeEnum = {
    ALL: 0,
    TUTORIAL: 1,
    MASTER_CLASS: 2,
    WEBINAR: 3,
    SKILL_PATH: 4
}

export const ApiBookmarkOrderByEnum = {
    LATEST: 0,
    OLDEST: 1,
}

export const ApiQueryTargetTypeEnum = {
    ALL: 0,
    GROUP_AND_LINK: 1,
    ONLY_VIDEO: 2
}

export const ApiBannerCategoryIdEnum = {
    TEXT_BANNER: 2903,
    CAMPAIGN: 2902
}

export const SpeakerTypeEnum = {
    MAIN: 0,
    GUEST: 1
}

export const ApiSkillPathOrderByEnum = {
    BACKEND_SORT: 0,
    LATEST: 1,
    OLDEST: 2,
}

export const ApiSkillPathMediaMenuEnum = {
    ALL: 0,
    TUTORIAL: 1,
    MASTER_CLASS: 2
}